import gql from "graphql-tag";

export const AcceptInviteMutation = gql`
  mutation acceptInvite($token: String!) {
    acceptInvite(token: $token)
  }
`;
